/** Server closes with 4000 when the in-memory doc was evicted (version restore, etc.). */
export const SERVER_DOCUMENT_RESET_CLOSE_CODE = 4000;

/** WebSocket close codes that mean the server dropped state and clients must sign out. */
export const SERVER_FORCED_RECONNECT_CLOSE_CODES = new Set([
    SERVER_DOCUMENT_RESET_CLOSE_CODE, // version restore / doc eviction
    1011, // internal error / init failed
    1012, // service restart (sent on graceful ws-collaboration shutdown)
]);

/**
 * RFC 6455 close codes for a clean, expected handshake (not a dropped/reset connection).
 * 1000 = normal closure, 1001 = going away (e.g. tab navigating/closing).
 */
export const NORMAL_CLOSE_CODES = new Set([1000, 1001]);

export function isServerDocumentResetClose(code) {
    return code === SERVER_DOCUMENT_RESET_CLOSE_CODE;
}

export function isServerForcedReconnectClose(code) {
    return SERVER_FORCED_RECONNECT_CLOSE_CODES.has(code);
}

/** True for any close that isn't a clean/expected handshake — worth treating as a reset signal. */
export function isAbnormalClose(code) {
    return !NORMAL_CLOSE_CODES.has(code);
}
